import { defineMessage } from 'services/localization';

export const messages = {
    budget: defineMessage('budget'),
    remaining: defineMessage('remaining'),
    bills: defineMessage('bills'),
    purchaseOrders: defineMessage('purchase_orders'),
    approved: defineMessage('approved'),
    onApproval: defineMessage('on_approval'),
    noteOne: defineMessage('all_amounts_do_not_incl_ent_templatedisplayname'),
    noteTwo: defineMessage('this_amount_includes_no__billed_purchase_orders'),
};
